import type { ChannelForm, FormStep } from './ChannelForm.types';
import { Channel, Commercial, LineItem, Overall } from './components';
import { isMeasurementChannel } from '../../utils/measurementChannel';

export type RateSource = 'MANUAL' | 'PACKAGE' | 'TECH_FEE';

export const STEPS: FormStep[] = [
  {
    title: 'Line item details',
    name: 'channel',
    content: <Channel />
  },
  {
    title: 'Rate/Package',
    name: 'commercial',
    content: <Commercial />
  },
  {
    title: 'Format/KPI',
    name: 'lineItem',
    content: <LineItem />
  },
  {
    title: 'Overall',
    name: 'overall',
    content: <Overall />
  }
];

export const INITIAL_STATE: ChannelForm = {
  channel: undefined,
  flightDates: undefined,
  formats: undefined,
  kpi: undefined,
  product: undefined,
  publishers: undefined,
  targetingDetails: undefined,
  targetingDevices: undefined,
  poweredBySkyrise: false,
  sellRate: undefined,
  budget: undefined,
  buyingMetric: undefined,
  rateSource: 'MANUAL',
  packageId: undefined,
  applyAgencyDiscount: true,
  valueAddType: 'VALUE_POT',
  valueAddInputMode: 'PERCENT',
  valueAddPercent: undefined,
  valueAddAbsolute: undefined,
  feePercent: undefined,
  feeBaseChannel: undefined,
  country: undefined,
  currency: undefined,
  dsp: undefined
};

export function getBookingFieldNames(rateSource?: RateSource, channel?: string): string[] {
  const fields = ['country', 'currency'];
  const hideDsp =
    rateSource === 'PACKAGE' || rateSource === 'TECH_FEE' || isMeasurementChannel(channel);
  if (!hideDsp) fields.push('dsp');
  return fields;
}

export function getStepFieldNames(step: number, rateSource?: RateSource, channel?: string): string[] {
  if (step === 0) {
    const base = ['channel', 'rateSource', 'flightDates', 'targetingDetails', 'country', 'currency'];
    if (rateSource === 'TECH_FEE') return [...base, 'feePercent'];
    if (rateSource === 'PACKAGE' || isMeasurementChannel(channel)) return [...base, 'budget'];
    return [...base, 'budget', 'dsp'];
  }
  if (step === 1) {
    if (rateSource === 'PACKAGE') return ['packageId', 'kpi'];
    if (rateSource === 'TECH_FEE') return [];
    return ['product', 'kpi', 'buyingMetric', 'sellRate'];
  }
  if (step === 2) {
    return rateSource === 'TECH_FEE' ? [] : ['formats'];
  }
  return [];
}
